<template>
  <div class="top" :style="{'backgroundColor': `${colorTop}`}">
    <div class="top_content">
      <div @click="gotoClick(1)">
        <i class="icon-gengduo iconfont"></i>
      </div>
      <div @click="gotoClick(2)" class="top_content_logo">
        <!-- <img src="../../assets/img/logo.png" alt="" /> -->
        {{$t(`webName`)}}
      </div>
      <van-icon @click="gotoClick(3)" size="35" name="manager-o" />
      <van-icon @click="gotoClick(5)" size="35" name="like-o" />
      <van-icon @click="gotoClick(4)" size="35" :badge="userInfo.car_num ?userInfo.car_num : 0 " name="cart-o" />
    </div>
    <van-popup v-model="popupShow" position="left" :style="{ height: '100%', width: '100%' }">
      <div class="top_popup">
        <div class="top_popup_close">
          <div class="top_popup_close_menu" @click="clickClose">
            <i class="icon-gengduo iconfont"></i>
            <div>{{ $t("close") }}</div>
          </div>
          <div class="top_popup_close_x" @click="clickClose">×</div>
        </div>
        <div>
          <van-search v-model="value" right-icon="search" left-icon @search="search" shape="round"
            :placeholder="$t(`shousuo`)" />
        </div>
        <div class="top_popup_cart">
          <div class="top_popup_cart_left">
            <van-icon name="shopping-cart-o" />
            <div>{{ $t("car") }} （{{userInfo.car_num}}）</div>
          </div>：
          <div class="top_popup_cart_right">{{ userInfo.car_count ? userInfo.car_count:0}}{{ $t("yuan") }}</div>
        </div>
        <div class="top_popup_btn" v-if="!tokenFalse">
          <div @click="loginReg(0)"> {{ $t('disembark') }}</div>
          <div class="top_popup_btn_reg" @click="loginReg(1)"> {{ $t("register") }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getToken, setToken, removeToken } from '@/utils/auth'
export default {
  name: "hander",

  data() {
    return {
      popupShow: false,
      value: '',
      userInfo:'',
      tokenFalse:false,
      colorTop:'#8ebe38'
    };
  },
  mounted() {
    this.colorTop = window.webConfig.color
    let token =  getToken()
    if(token){
      this.tokenFalse = true
      this.handleRefresh()
    }
  },
  methods: {
    gotoClick(index) {
      switch (index) {
        case 1:
        this.popupShow = true;
          if ( this.tokenFalse) {
            this.handleRefresh()
          }
          break;
        case 2:
          this.$router.push('/home')
          break;
        case 3:
          if ( this.tokenFalse) {
            this.$router.push('/mycenter')
          } else {
            this.$router.push('/login')
          }
          break;
        case 4:
          if ( this.tokenFalse) {
            this.$router.push('/car')
          } else {
            this.$router.push('/login')
          }
          break;
          case 5:
          if ( this.tokenFalse) {
            this.$router.push('/buyList')
          } else {
            this.$router.push('/login')
          }
          break;
        default:
          break;
      }

    },
    async handleRefresh() {
      this.loading = true
      const res = await this.$http.home.userInfo();
      this.loading = false
      if (res.code == 200) {
        this.userInfo = res.data
        store.commit("SET_USERINFO", res.data);
      }
    },
    clickClose() {
      this.popupShow = false;
    },
    loginReg(index) {
      if (index == 0) {
        this.$router.push('/login')
      }
      if (index == 1) {
        this.$router.push('/register')
      }
    },
    search() {
      this.popupShow = false
      this.$router.push({ path: "search", query: { value: this.value } });
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .van-field__body {
  padding: 0 10px;
}

/deep/ .van-popup {
  background-color: #fff;
}

.top {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 20px;
  background-color: #8ebe38;
  z-index: 1000;

  .top_content {
    height: 74px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    vertical-align: top;

    .top_content_logo {
      font-weight: 900;
      font-size: 20px;
      width: 50%;
    }

    img {
      height: 30px;
      color: #000;
    }
  }
}

.top_popup {
  background-color: #fff;
  padding-top: 50px;

  .top_popup_close {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #f7f7f7;

  }

  .top_popup_close_menu {
    display: flex;
    align-items: center;

    i {
      font-size: 12px;
      margin: 0 8px;
    }
  }

  .top_popup_close_x {
    width: 40px;
    height: 40px;
    font-weight: 900;
    font-size: 25px;
    color: #fff;
    background-color: #e35252;
    text-align: center;
    line-height: 40px;
  }

  .top_popup_btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: #fff;

    div {
      width: 45%;
      padding: 12px 0;
      text-align: center;
      background-color: #e35252;
      color: #fff;
    }

    .top_popup_btn_reg {
      background-color: #5c5c5c;
    }
  }

  .top_popup_cart {
    display: flex;
    align-items: center;
    padding: 16px 16px;
    background-color: #f7f7f7;
    margin: 8px 12px 12px;

    .top_popup_cart_left {
      width: 100px;
      display: flex;
      align-items: center;

      i {
        margin-right: 8px;
        color: #e35252;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subcomponents/top.vue